
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/country",
      function () {
        return require("private-next-pages/node/country.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/country"])
      });
    }
  